import { FC } from 'react';

import clsx from 'clsx';

import { TelegramChatSettingsItemContentFactory } from './TelegramChatSettingsItemContentFactory';
import { TelegramChatSettingsChatItemProps } from './types';
import { getConditionalMessageDetails } from './utils';

import styles from './TelegramChatSettingsItem.module.css';

const { messageTimestamp, messageContent, messageAvatar, messageItem } = styles;

export const TelegramChatSettingsItem: FC<TelegramChatSettingsChatItemProps> = ({ telegramChat, message }) => {
  const { message: messageValue, createdAt, isAdminMessage, isAIMessage, contentType } = message;
  const { userNickname } = telegramChat;

  const formattedTime = new Date(createdAt).toLocaleString();

  const { messageClass, imageSrc } = getConditionalMessageDetails(isAdminMessage || isAIMessage, null);

  let messageName = userNickname;

  if (isAdminMessage) {
    messageName = 'Admin';
  } else if (isAIMessage) {
    messageName = '🤖 AI';
  }

  return (
    <div className={clsx(messageItem, messageClass)}>
      <img src={imageSrc ?? ''} alt={userNickname} className={messageAvatar} />

      <div className={messageContent}>
        <div className={messageName}>{messageName}</div>

        <TelegramChatSettingsItemContentFactory contentType={contentType} value={messageValue} />

        <div className={messageTimestamp}>{formattedTime}</div>
      </div>
    </div>
  );
};
